var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBallSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3222 31.6886C10.6276 33.4034 2.18886 27.7473 0.495458 19.1307C-1.14539 10.4232 4.44579 2.00702 13.1403 0.292258C21.7823 -1.33155 30.2019 4.25287 31.9145 12.9411C33.6079 21.5577 27.9449 29.9931 19.3222 31.6886Z",
    fill: "url(#paint0_radial_810_77795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_810_77795",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5547 9.82397) rotate(77.72) scale(22.5049 22.5216)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00887753,
    stopColor: "#C9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1723,
    stopColor: "#B5ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377898,
    stopColor: "#A9E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582742,
    stopColor: "#78D4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800743,
    stopColor: "#00B4F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0198CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallSmall);
export default __webpack_public_path__ + "static/media/ballSmall.48c017f1e3b7b6f3ae2763e2f35161a3.svg";
export { ForwardRef as ReactComponent };